module.exports = __webpack_public_path__ + "static/media/campus-catering.ee23b6a6.jpg";